import type {AuthenticatedUserFragment} from "@app/common/services/auth/auth.service.generated"

/**
 * The self-service starting/tutorials screen shows for any self-service session — a real self-service
 * account or the staff self-service preview — that has not permanently dismissed it ("Don't show this
 * again").
 *
 * The discriminator is the active SILO being self-service (its organization's derived accountType), not
 * a user field. A self-service signup auto-creates its organization with type EnterpriseCloud, so org
 * type can't distinguish it; keying off the silo also covers the staff preview with no special case and
 * needs no staff check. Onboarding state is a user property the silo doesn't carry, so the "don't
 * surface over the first-run onboarding flow" gate — and showing once per login rather than on every app
 * load — live in the service that arms and calls this.
 */
export const shouldShowStartingScreen = (isSelfServiceSilo: boolean, user: AuthenticatedUserFragment | null | undefined): boolean =>
    isSelfServiceSilo && !!user && !user.startingScreenDismissedAt
